import React from "react";

const Login = () => {
  return (
    <div className="container mx-auto py-8">
      <h1>Login</h1>
    </div>
  );
};

export default Login;
